import React, { useState, useEffect } from "react";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { TextField } from "@mui/material";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";

import IconButton from "@mui/material/IconButton";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import Chip from "@mui/material/Chip";

import dayjs from "dayjs";

import Header from "./components/header";
import { useParams } from "react-router-dom";

import axios from "axios";

import SlotDialog from "./components/SlotDialog";

const boxStyles = {
  my: 1,
  display: "flex",
  justifyContent: "space-between",
  fontSize: "1.2em",
};

const commonStyles = {
  p: 2,
  mb: 2,
  border: 1,
  borderRadius: "4px",
  borderColor: "#e8e8e8",
};

let service_options = [
  { id: "Reumatologie", label: "Reumatologie" },
  { id: "Recuperare Medicala", label: "Recuperare Medicala" },
];

const dayNames = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function EditDoctor() {
  const { docId } = useParams();

  const [docApi, setDocApi] = useState({});
  const [slotApi, setSlotApi] = useState([]);
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState(false);
  //   const [action, setAction] = useState(""); //create, update, delete

  const [slotDiag, setSlotDiag] = useState({
    slot_name: "",
    action: "",
    index: null,
    item: null,
  });

  const updateDocApi = async (item) => {
    delete item["slot"];

    const response = await axios.patch(
      process.env.REACT_APP_API_URL + `/doctors/` + item._id,
      item
    );
    if ((response.statusText = "OK")) {
      // console.log("saved doc");
      setNotification(true);
    }
  };

  const updateSlotApi = async (item) => {
    item.service_type = docApi.specialitate;

    const response = await axios.patch(
      process.env.REACT_APP_API_URL + `/slots/` + item._id,
      item
    );
    if ((response.statusText = "OK")) {
      // console.log("saved doc slot");
      setNotification(true);
    }
  };

  const getDocApi = async () => {
    const { data } = await axios.get(
      process.env.REACT_APP_API_URL + `/doctors/` + docId
    );
    // console.log("slot", data.slot);
    setDocApi(data);
    setSlotApi(data.slot);
  };

  useEffect(() => {
    getDocApi();
  }, []);

  const handleSave = () => {
    // console.log("save doctor");
    updateDocApi(docApi);
    updateSlotApi(slotApi);
  };

  const handleChange = ({ target: { name, value } }) => {
    // console.log("edit_change", name, value);

    setDocApi({
      ...docApi,
      [name]: value,
    });
  };

  const handleCloseDiag = () => {
    setOpen(false);
  };

  const handleDialog = (slot_name, index, item, action) => {
    setSlotDiag({ ...slotDiag, slot_name, index, item, action });
    setOpen(true);
  };

  const handleChangeDiag = ({ target: { name, value } }) => {
    let item = slotDiag.item;

    if (slotDiag.slot_name === "blocked_days") {
      // console.log("handleChangeDiag", name, value);
      item = { ...item, [name]: value };
    } else {
      item = { ...item, [name]: dayjs(value).format("HH:mm") };
    }

    // console.log("after_change", item);

    setSlotDiag({ ...slotDiag, item });
  };

  const handleDeleteSlot = (slot_name, index) => {
    if (window.confirm("Do you really want to delete this slot?")) {
      // console.log("handledeleteslot", slot_name, index);
      let arr = slotApi[slot_name];
      arr.splice(index, 1);
      let update = { [slot_name]: arr };
      // console.log(update);
      setSlotApi({ ...slotApi, update });
    }
  };

  const handleActionDiag = () => {
    let arr = slotApi[slotDiag.slot_name];

    if (slotDiag.action === "new") {
      arr.push(slotDiag.item);
    } else if (slotDiag.action === "edit") {
      arr[slotDiag.index] = slotDiag.item;
    }

    let update = { [slotDiag.slot_name]: arr };
    // console.log(update);
    setSlotApi({ ...slotApi, update });

    // console.log("save");
    setOpen(false);
  };

  const handleBackdropClick = () => {
    //these fail to keep the modal open
    event.stopPropagation();
    return false;
  };

  const handleCloseNotification = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setNotification(false);
  };

  return (
    <>
      <Header></Header>

      <Snackbar
        open={notification}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={1000}
        onClose={handleCloseNotification}
      >
        <Alert
          onClose={handleCloseNotification}
          severity="success"
          sx={{ width: "100%" }}
        >
          Saved Changes!
        </Alert>
      </Snackbar>
      <Container maxWidth="xl">
        <Grid
          container
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Grid item xs={10}>
            <Typography variant="h6" sx={{ mt: 3 }}>
              Edit Doctor
            </Typography>
            <Typography variant="h4" sx={{}}>
              {docApi.name ?? ""}
            </Typography>
          </Grid>
          <Grid item xs={2} sx={{ textAlign: "right" }}>
            <Button
              variant="contained"
              color="error"
              size="large"
              onClick={handleSave}
            >
              Save Changes
            </Button>
          </Grid>
        </Grid>
        <Paper elevation={3} sx={{ mt: 3, p: 2 }}>
          <Grid
            container
            alignItems="center"
            direction="row"
            justifyContent="space-between"
          >
            <Grid item xs={4}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <TextField
                  fullWidth
                  name="name"
                  label="Nume"
                  id="name"
                  value={docApi.name ?? ""}
                  onChange={handleChange}
                ></TextField>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <TextField
                  fullWidth
                  select
                  label="Service"
                  name="specialitate"
                  id="demo-simple-select-filled"
                  value={docApi.specialitate ?? ""}
                  onChange={(event, newValues) => {
                    // console.log(newValues);
                    handleChange({
                      target: {
                        name: "specialitate",
                        value: newValues.props.value,
                      },
                    });
                  }}
                >
                  {service_options.map((opt) => (
                    <MenuItem key={opt.id} value={opt.id}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <TextField
                  fullWidth
                  name="email"
                  label="Email"
                  id="email"
                  value={docApi.email ?? ""}
                  onChange={handleChange}
                ></TextField>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <TextField
                  fullWidth
                  name="phone"
                  label="Telefon"
                  id="phone"
                  value={docApi.phone ?? ""}
                  onChange={handleChange}
                ></TextField>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <TextField
                  fullWidth
                  name="duration"
                  label="Slot Duration"
                  id="duration"
                  value={slotApi.slot_duration ?? ""}
                  onChange={(e) => {
                    setSlotApi({ ...slotApi, slot_duration: e.target.value });
                  }}
                ></TextField>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>

        <Grid
          container
          alignItems="flex-start"
          direction="row"
          justifyContent="space-between"
        >
          <Grid item xs={12} md={6}>
            <Typography sx={{ my: 3, mx: 0 }} variant="h6" component="div">
              Work Hours
            </Typography>
            {slotApi &&
              dayNames.map((day) => (
                <React.Fragment key={day}>
                  <Box sx={{ ...commonStyles }}>
                    <Typography
                      sx={{ ...boxStyles }}
                      variant="h6"
                      component="div"
                    >
                      {day.charAt(0).toUpperCase() + day.slice(1)}
                      <Button
                        variant="contained"
                        size="small"
                        onClick={(e) =>
                          handleDialog(
                            "slots_" + day,
                            0,
                            { start: "00:00", end: "00:00" },
                            "new"
                          )
                        }
                      >
                        + Add
                      </Button>
                    </Typography>
                    {/* {`slots_` + day} */}
                    <List sx={{ py: 0 }}>
                      {slotApi["slots_" + day] &&
                        slotApi["slots_" + day].map((slot, index) => (
                          <React.Fragment key={index}>
                            <Divider></Divider>
                            <ListItem
                              sx={{ pl: 0, pb: 0 }}
                              secondaryAction={
                                <>
                                  <IconButton
                                    aria-label="edit"
                                    onClick={(e) =>
                                      handleDialog(
                                        "slots_" + day,
                                        index,
                                        slot,
                                        "edit"
                                      )
                                    }
                                  >
                                    <ModeEditIcon />
                                  </IconButton>
                                  <IconButton
                                    edge="end"
                                    aria-label="delete"
                                    color="error"
                                    onClick={(e) =>
                                      handleDeleteSlot("slots_" + day, index)
                                    }
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </>
                              }
                            >
                              <ListItemText
                                primary={slot.start + " - " + slot.end}
                                // secondary={"slots_" + day}
                              />
                            </ListItem>
                          </React.Fragment>
                        ))}
                    </List>
                  </Box>
                </React.Fragment>
              ))}
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ ml: 4 }}>
              <Typography sx={{ my: 3, mx: 0 }} variant="h6" component="div">
                Blocked Days
              </Typography>

              <Box sx={{ ...commonStyles }}>
                <Typography
                  sx={{ ...boxStyles, fontSize: "1em" }}
                  variant="subtitle2"
                  component="div"
                >
                  Set the days that will be the blocked.
                  <Button
                    variant="contained"
                    size="small"
                    onClick={(e) =>
                      handleDialog(
                        "blocked_days",
                        0,
                        { start: dayjs(), end: dayjs(), description: "" },
                        "new"
                      )
                    }
                  >
                    + Add Days
                  </Button>
                </Typography>
                <List sx={{ py: 0 }}>
                  {slotApi.blocked_days &&
                    slotApi.blocked_days.map((slot, index) => (
                      <React.Fragment key={index}>
                        <Divider></Divider>
                        <ListItem
                          sx={{ pl: 0, pb: 0 }}
                          secondaryAction={
                            <>
                              <IconButton
                                aria-label="edit"
                                onClick={(e) =>
                                  handleDialog(
                                    "blocked_days",
                                    index,
                                    slot,
                                    "edit"
                                  )
                                }
                              >
                                <ModeEditIcon />
                              </IconButton>
                              <IconButton
                                edge="end"
                                aria-label="delete"
                                color="error"
                                onClick={(e) =>
                                  handleDeleteSlot("blocked_days", index)
                                }
                              >
                                <DeleteIcon />
                              </IconButton>
                            </>
                          }
                        >
                          <ListItemText
                            secondary={
                              dayjs(slot.start).format("DD MMMM YYYY") +
                              (slot.start != slot.end
                                ? " - " + dayjs(slot.end).format("DD MMMM YYYY")
                                : "")
                            }
                            primary={slot.description}
                          />
                        </ListItem>
                      </React.Fragment>
                    ))}
                </List>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <SlotDialog
          open={open}
          onBackdropClick={handleBackdropClick}
          disableEscapeKeyDown
          slot={slotDiag}
          onClose={handleCloseDiag}
          onChangeDiag={handleChangeDiag}
          onSave={handleActionDiag}
        ></SlotDialog>
        <Box sx={{ mb: 10 }}></Box>
      </Container>
    </>
  );
}
